import { io } from 'socket.io-client';

export const CLASSROOM_REALTIME_EVENTS = {
  ASSESSMENT_ACTIVATED: 'assessment:activated',
  ASSESSMENT_DEACTIVATED: 'assessment:deactivated',
  ASSESSMENT_VISIBILITY_CHANGED: 'assessment:visibility_changed',
  ASSESSMENT_UPDATED: 'assessment:updated',
  ASSIGNMENT_DUE_REACHED: 'assignment:due_reached',
  ASSIGNMENT_VISIBILITY_CHANGED: 'assignment:visibility_changed',
  ASSIGNMENT_UPDATED: 'assignment:updated',
  LIVE_CLASS_CREATED: 'live_class:created',
  LIVE_CLASS_UPDATED: 'live_class:updated',
  LIVE_CLASS_DELETED: 'live_class:deleted',
  LIVE_CLASS_STARTED: 'live_class:started',
  LIVE_CLASS_ENDED: 'live_class:ended',
};

let sharedSocket = null;
let sharedSocketUsers = 0;
let disconnectTimer = null;

const SOCKET_IDLE_MS = 1500;

export const acquireClassroomSocket = () => {
  const token = localStorage.getItem('token');
  const websocketUrl = process.env.REACT_APP_WEBSOCKET_URL || process.env.REACT_APP_API_URL;

  if (!token || !websocketUrl) {
    return null;
  }

  if (disconnectTimer) {
    clearTimeout(disconnectTimer);
    disconnectTimer = null;
  }

  if (sharedSocket) {
    sharedSocketUsers += 1;
    if (sharedSocket.disconnected) {
      sharedSocket.io.opts.query = { token };
      sharedSocket.connect();
    }
    return sharedSocket;
  }

  sharedSocket = io(websocketUrl, {
    query: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 8,
    reconnectionDelay: 1000,
    timeout: 10000,
  });

  sharedSocketUsers = 1;
  return sharedSocket;
};

export const releaseClassroomSocket = () => {
  sharedSocketUsers = Math.max(0, sharedSocketUsers - 1);
  if (sharedSocketUsers > 0 || !sharedSocket) return;

  // Delay close so React StrictMode remounts reuse the same socket
  // instead of aborting a handshake (Chrome: "WebSocket is closed before
  // the connection is established").
  disconnectTimer = setTimeout(() => {
    disconnectTimer = null;
    if (sharedSocketUsers === 0 && sharedSocket) {
      sharedSocket.disconnect();
      sharedSocket = null;
    }
  }, SOCKET_IDLE_MS);
};

export const joinClassroomRoom = (socket, classroomId) => {
  if (!socket || classroomId == null) return;
  socket.emit('joinClassroomRoom', classroomId);
};

export const leaveClassroomRoom = (socket, classroomId) => {
  if (!socket || classroomId == null) return;
  socket.emit('leaveClassroomRoom', classroomId);
};
